<template>
    <div class="doc-section">
        <h1>Notificaciones</h1>
        <p>
            El sistema cuenta con un centro de alertas ubicado en la barra superior, permitiendo al usuario estar al
            tanto de los eventos relevantes en tiempo real sin interrumpir su navegación.
        </p>

        <plataformaNavegacion @cambio-plataforma="actualizarVista" />


        <h2>Funcionamiento del Icono</h2>
        <p>El icono de la campana actúa como un indicador visual dinámico:</p>

        <ol class="ul-contenedor step-list">
            <li><strong>Alerta Activa:</strong> Cuando llega una notificación nueva, la campana mostrará un círculo rojo
                sobrepuesto.</li>
            <li><strong>Sin Notificaciones:</strong> Una vez revisado el listado o cuando no existan alertas pendientes,
                se mostrará únicamente el icono de la campana sin indicadores adicionales.</li>
        </ol>

        <h2>Gestión de Alertas</h2>
        <p>Para interactuar con las notificaciones, realice lo siguiente:</p>

        <ol class="ul-contenedor step-list">
            <li>Haga clic sobre el icono de <strong>Campana</strong> para desplegar una vista previa de las alertas
                recientes.</li>
            <li>Dentro del menú desplegable, localice el botón <strong>Ver todas</strong> al final del componente.</li>
            <li>Al hacer clic en este botón, el sistema lo redirigirá automáticamente a la sección de
                <strong>Monitoreo</strong> y abrirá el menú detallado de alertas.</li>
        </ol>

        <div class="info-card">
            <p>
                <strong>Nota:</strong> La vista previa permite una lectura rápida, pero para gestionar el historial
                completo es necesario acceder al menú detallado a través del botón "Ver todas".
            </p>
        </div>

        <h3>Referencia Visual</h3>
        <div v-if="plataforma === 'web'" class="platform-content">
            <CarruselAciqui :items="imagenesNotificaciones" />
        </div>
        <div v-if="plataforma === 'moviles'" class="platform-content">
            <CarruselAciqui :items="imagenesNotificacionesMoviles" />
        </div>

    </div>
</template>

<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {
    name: 'NotificacionesDoc',
    components: { CarruselAciqui,plataformaNavegacion },
    data: () => ({
        plataforma: 'web',
        imagenesNotificaciones: [
            {
                nombre: "Lista de Notificaciones",
                url: "img/notificaciones/listadoNotificaciones.png",
                descripcion: "Vista previa del menú de alertas en la barra superior."
            }
        ],
        imagenesNotificacionesMoviles: [
            {
                nombre: "Lista de Notificaciones",
                url: "img/notificaciones/listadoNotificaciones.png",
                descripcion: "Vista previa del menú de alertas en la barra superior."
            },
            {
                nombre: "",
                url: "img/notificaciones/moviles/navbar_notificaciones.png",
                descripcion: ""
            }
        ]
    }),
    methods: {
        actualizarVista(val) {
            this.plataforma = val;
        }
    }
}
</script>